import React from "react";
import { LinearProgress } from "@material-ui/core/";
import { ReactComponent as SavingGraphic } from "../../../assets/svg/video-studio-saving.svg";
import { Button } from "../../../components/common";

function VideoProgess(props: any) {
  const progress = Number(props.progress) || 0;
  const hasProgress = progress > 0;

  const handleClose = (e: any) => {
    if (typeof props.handleOnClose === "function") {
      props.handleOnClose(e);
    }
  };

  return (
    <div className="video-progress-wrapper">
      <div className="info">
        <SavingGraphic />
        <h2>Hang Tight!</h2>
        <p>
          {hasProgress
            ? `Saving your video… ${Math.round(progress)}%`
            : "You can’t rush perfection."}
        </p>
        <Button className="btn-cancel" variant="contained" onClick={handleClose}>
          Close
        </Button>
      </div>
      <LinearProgress
        variant={hasProgress ? "determinate" : "indeterminate"}
        value={progress}
      />
    </div>
  );
}

export default VideoProgess;
